import * as React from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { Asset } from '../../Model/Asset';
import { Attribute } from '../../Model/Attribute';
import { Product, ProductInterface } from '../../Model/Product';
import { AttributeUtility } from '../../Service/AttributeUtility';
import { ObjectUtility } from '../../Service/ObjectUtility';

export abstract class ProductView<T> extends React.PureComponent<T> {
    public static contextType = AppContextType;
    public context: AppContext<Product> = {} as AppContext<Product>;

    protected displayString(product: ProductInterface | undefined, key: string): string | null {
        const value = ObjectUtility.valueForKeyPath<ProductInterface | undefined, Attribute>(product, key);
        if (value instanceof Attribute) {
            return value.displayString;
        } else {
            return value || '';
        }
    }

    protected asset(product: ProductInterface | undefined, key: string): Asset | undefined {
        return AttributeUtility.getProductAsset(product, key, this.context.i18n.localeCode);
    }
}
